import React, { Component } from 'react';
// import logo from './logo.svg';
// import './App.css';
import SiteHolder from '../src/components/helperFiles/SiteHolder';

class App extends Component {
  render() {
    return (
      <div>
        <SiteHolder />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js